export default __webpack_public_path__ + "static/backgroundOffers-606e1eebb117af92a682810e9ac9efb2.svg";